/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { LoginComponent } from '../login/login.component';

export const authSharedRoutes: Route[] = [
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        component: LoginComponent,
      }
    ],
  }
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(authSharedRoutes)],
  providers: [],
  declarations: [],
})
export class AuthSharedRoutingModule {}
